import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';

const HeartRateForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={true}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="clinicalstudy.heartRate">
      <InputHandler
        type="NumberField"
        editing={true}
        name="heartRate"
        formData={formData}
        placeholder="clinicalstudy.heartRatePlaceholder"
      />
    </FormRow>
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'heartRate'>>;
}

export default HeartRateForm;
